import "./SinglePostTemplate.module.css"
import VoltMainHeader from "@/reusable_sections/Header"
import SinglePostTemplateSection from "./sections/SinglePostTemplateSection"
import Footer from "@/reusable_sections/Footer"

export default function SinglePostTemplatePage() {

  return (
    <div>
      <VoltMainHeader />
      <SinglePostTemplateSection />
      <Footer />
    </div>
  )
}
